import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { menuList } from "../data/menu-list";
import { useWindowSize } from "../Hooks/WindowSize";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import { updateIsInternRequest } from "../redux/action/profileAction";
import { engApi } from "../api/engApi";
import Copyright from "./Copyright";
import { permissions } from "../data/permissions";

const SideMenu = () => {
  const dispatch = useDispatch();
  const size = useWindowSize();
  const location = useLocation();
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profileReducer.profile);
  // const isMember = useSelector((state) => state.profileReducer.isMember);
  // const isInternRequest = useSelector(
  //   (state) => state.profileReducer.isInternRequest
  // );

  // const profile = {
  //   b_id: "4",
  //   gpa: "4",
  //   id: "55050419",
  //   m_role: "student",
  //   name: "นายนรุตม์ สาหาร",
  //   status: "0",
  // };
  // const getUsername = 55050419;
  const getUsername = localStorage.getItem("username");
  const [internDetail, setInternDetail] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [isInternRequest, setIsInternRequest] = useState(false);
  const [internStudent, setInternStudent] = useState(null);
  const [menuData, setMenuData] = useState([]);

  const { pathname } = location;

  let mobileMode = false;
  if (size.width > 1000) {
    mobileMode = false;
  } else if (size.width > 300) {
    mobileMode = true;
  }

  const getInternMember = async () => {
    const resMember = await engApi.get("/intern-student/");

    try {
      const match = await resMember.data?.find((el) => el.id == getUsername);
     
      if (match) {
        setIsMember(true);
        setInternStudent(match);
        console.log("is member", isMember)

      } else {
        const resMember2 = await engApi.get("/intern-student2/");
        const match2 = await resMember2.data?.find((el)=> el.id == getUsername);
        
        if(match2){
         
          setIsMember(true);
          setInternStudent(match2);
          
        }else{
          
          setIsMember(false);
          setInternStudent(null);
        }
      }


    } catch (err) {
      console.log(err);
    }
  };

  const getInternData = async () => {
    const response = await engApi.get("/get-internship-request/");

    try {
      const match = await response.data?.find((el) => el.st_id == getUsername);

      if (match) {
        // dispatch(updateIsInternRequest(true));
        setInternDetail(match);
        setIsInternRequest(true);
      } else {
        setIsInternRequest(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getInternMember();
    getInternData();
  }, [profile]);

  const menuList = [
    {
      menu_name: "สรุปข้อมูลนิสิตฝึกงาน/สหกิจศึกษา",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/dashboard-internship",
      permission: 4,
    },

    {
      menu_name: "การประเมินผล",
      type: "collapse",
      permission: 2,
      children: [
        {
          menu_name: "ฝึกงาน 2 เดือน",
          type: "link",
          isAccessDenined: "",
          pathUrl: "dashboard-evaulation",
          
        },

        {
          menu_name: "สหกิจศึกษา",
          type: "link",
          isAccessDenined: "",
          pathUrl: "dashboard-evaulationcoop",
          
        },

        {
          menu_name: "แสดงผลการประเมิน 2 เดือน",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/internship-evaluation",
          
        },

        {
          menu_name: "ประเมินผลนิสิตรายบุคคล",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/student-evaluation",
          
        },

        {
          menu_name: "📊 รายงานการวิเคราะห์ AI",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/ai-analysis-report",
          
        },

        {
          menu_name: "ภาพรวมการประเมินคณะ",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/faculty-dashboard",
          
        },



      ],
    },


    {
   
      menu_name: "สรุปข้อมูลการยื่นความประสงค์",
      type: "collapse",
      permission: 2,
      children: [
        {
          menu_name: "แยกตามรายชื่อนิสิต",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/dashboard",
        },
        {
          menu_name: "แยกตามรายชื่อบริษัท",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/dashboard-company",
        },
      ],
    },
    {
      menu_name: "จัดการเอกสาร",
      type: "collapse",
      permission: 1,
      children: [
        {
          menu_name: "หนังสือขอความอนุเคราะห์",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/task",
        },
        {
          menu_name: "แบบตอบรับฝึกงาน/หนังสือส่งตัว",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/internship-answer",
        },
        {
          menu_name: "การอบรมเตรียมความพร้อม",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/event",
        },
        {
          menu_name: "จัดการข้อมูลนิสิต",
          type: "link",
          isAccessDenined: "",
          pathUrl: "/student-manage",
        },
      ],
    },

    {
      menu_name: "อนุมัติคำขอฝึกงาน",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/approval",
      permission: 3,
    },
    {
      menu_name: "จัดการสถานประกอบการใหม่",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/company-review",
      permission: 2,
    },
    {
      menu_name: "Profile",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/profile",
      permission: 5,
    },
    {
      menu_name: "Form",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/student-form",
      permission: 5,
    },
    {
      menu_name: "ยื่นความประสงค์ขอฝึกงาน",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/request-form",
      permission: 5,
    },
    {
      menu_name: "ข้อมูลสถานประกอบการ",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/company-detail",
      permission: 5,
    },
    {
      menu_name: "ข้อมูลสถานประกอบการที่แจ้งรับนิสิต",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/job-request",
      permission: 5,
    },
    {
      menu_name: "คู่มือ",
      type: "link",
      isAccessDenined: "",
      pathUrl: "/manual",
      permission: 5,
    },
  ];

  useEffect(() => {
    let pms = permissions.find(
      (p) => p?.role === profile?.role && p.b_id.indexOf(profile.b_id) !== -1
    );

   
    const menuFilter1 =
      !isMember && profile?.m_role == "student"
        ? menuList
        : menuList.filter((menu) => menu.pathUrl !== "/student-form");

    const menuFilter2 =
      profile?.m_role == "student" &&
      (!internDetail ||
        internStudent?.status_id == "15" ||
        internStudent?.status_id == "32")
        ? menuFilter1
        : menuFilter1.filter((menu) => menu.pathUrl !== "/request-form");

    const menuFilter3 =
      profile?.m_role == "student"
        ? menuFilter2
        : menuFilter2.filter((menu) => menu.pathUrl !== "/profile");

    const menuFilterPms = menuFilter3.filter(
      (menu) => pms?.id <= menu.permission
    );


     // if profile.m_
    // console.log({ menuFilterPms });

    setMenuData(menuFilterPms);

    // if (window.location.hostname == "localhost") {
    //   setMenuData(menuList);
    // }
  }, [isMember, internDetail, profile]);

  const displayMenu = (
    <ul className="sidebar-nav">
      {profile && profile.m_role == "staff" && (
        <>
          <li className="sidebar-item">
            <Link className="sidebar-link" to="/dashboard-internship">
              สรุปข้อมูลนิสิตฝึกงาน/สหกิจศึกษา
            </Link>

            <a
              data-bs-target="#dashboard"
              data-bs-toggle="collapse"
              className="sidebar-link collapsed"
            >
              สรุปข้อมูลการยื่นความประสงค์
            </a>
            <ul
              id="dashboard"
              className="sidebar-dropdown list-unstyled collapse show"
              data-bs-parent="#sidebar"
            >
              <Link className="sidebar-link" to="/dashboard">
                แยกตามรายชื่อนิสิต
              </Link>

              <Link className="sidebar-link" to="/dashboard-company">
                แยกตามรายชื่อบริษัท
              </Link>
            </ul>
          </li>

          {profile?.b_id == 0 && (
            <li className="sidebar-item">
              <a
                data-bs-target="#document-management"
                data-bs-toggle="collapse"
                className="sidebar-link collapsed"
              >
                จัดการเอกสาร
              </a>
              <ul
                id="document-management"
                className="sidebar-dropdown list-unstyled collapse show"
                data-bs-parent="#sidebar"
              >
                <Link className="sidebar-link" to="/task">
                  หนังสือขอความอนุเคราะห์
                </Link>

                <Link className="sidebar-link" to="/internship-answer">
                  แบบตอบรับฝึกงาน/หนังสือส่งตัว
                </Link>
              </ul>
              <Link className="sidebar-link" to="/event">
                การอบรมเตรียมความพร้อม
              </Link>
              <Link className="sidebar-link" to="/student-manage">
                จัดการข้อมูลนิสิต
              </Link>
            </li>
          )}

          <Link className="sidebar-link" to="/approval">
            อนุมัติคำขอฝึกงาน
          </Link>
          <Link className="sidebar-link" to="/company-review">
            จัดการสถานประกอบการใหม่
          </Link>
        </>
      )}

      {profile && profile.m_role == "student" && (
        <>
          <Link className="sidebar-link" to="profile">
            Profile
          </Link>
          {!isMember && (
            <Link className="sidebar-link" to="/student-form">
              Form
            </Link>
          )}

          {(!internDetail ||
            internStudent?.status_id == "15" ||
            internStudent?.status_id == "32") && (
            <Link className="sidebar-link" to="/request-form">
              ยื่นความประสงค์ขอฝึกงาน
            </Link>
          )}
        </>
      )}

      <>
        <Link className="sidebar-link" to="/company-detail">
          ข้อมูลสถานประกอบการ
        </Link>
        <Link className="sidebar-link" to="/job-request">
          ข้อมูลสถานประกอบการที่แจ้งรับนิสิต
        </Link>

        <Link className="sidebar-link" to="/manual">
          คู่มือ
        </Link>
      </>
    </ul>
  );

  const displayMenuLoop = (
    <ul className="sidebar-nav">
      {menuData.map((menu, mIndex) => {
        return menu.type === "link" ? (
          <li className="sidebar-item">
            <Link className="sidebar-link" to={menu.pathUrl}>
              {menu.menu_name}
            </Link>
          </li>
        ) : (
          <li className="sidebar-item">
            <a
              data-bs-target={`#dashboard-${mIndex}`}
              data-bs-toggle="collapse"
              className="sidebar-link collapsed"
            >
              {menu.menu_name}
            </a>
            <ul
              id={`dashboard-${mIndex}`}
              className="sidebar-dropdown list-unstyled collapse show"
              data-bs-parent="#sidebar"
            >
              {menu.children.map((child) => {
                return (
                  <Link className="sidebar-link" to={child.pathUrl}>
                    {child.menu_name}
                  </Link>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );

  // console.log(window.location.hostname);

  const displayNav = (
    <nav id="sidebar" className="">
      <div className="sidebar-content js-simplebar ">
        {profile || window.location.hostname == "localhost" ? (
          displayMenuLoop
        ) : (
          <Box display="flex" justifyContent="center">
            <Button color="primary" onClick={() => navigate("/login")}>
              Login
            </Button>
          </Box>
        )}
      </div>
    </nav>
  );

  const displayStaticMenu = (
    <div className="w-100 p-3">
      <div>
        <div className="mb-6 text-center" id="offcanvasScrollingLabel">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/assets/images/logo_white.png`} alt="logo" width="75%" />
          </Link>
        </div>
      </div>
      {displayNav}
    </div>
  );

  return (
    <div
      className="w-100 "
      style={{
        backgroundColor: "#283042",
        height: window.innerHeight,
        position: "relative",
      }}
    >
      {displayStaticMenu}

      <div
        className="ps-2 fixed-bottom"
        // style={{ position: "absolute", bottom: "0" }}
      >
        <Copyright color="white" variant="caption" />
      </div>
    </div>
  );
};

export default SideMenu;
